import { createContext, useContext, useMemo, useState, ReactNode } from 'react';

interface CrmAiChatUi {
  open: boolean;
  toggle: () => void;
  close: () => void;
}

const CrmAiChatUiContext = createContext<CrmAiChatUi | null>(null);

/** Shares the chat open/close state between the floating chat and the mobile bottom nav button. */
export const CrmAiChatProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);

  const value = useMemo(
    () => ({
      open,
      toggle: () => setOpen(prev => !prev),
      close: () => setOpen(false)
    }),
    [open]
  );

  return <CrmAiChatUiContext.Provider value={value}>{children}</CrmAiChatUiContext.Provider>;
};

export const useCrmAiChatUi = (): CrmAiChatUi => {
  const value = useContext(CrmAiChatUiContext);
  if (!value) throw new Error('useCrmAiChatUi must be used within CrmAiChatProvider');
  return value;
};
